export enum CustomListType {
    Unspecified = 0,
    /**
     * Legacy discriminator for the old auto-created "Familjemedlemmar" CustomList.
     * No new lists of this type are created — family members are real Member rows now.
     * Kept only to hide existing legacy lists until the data migration removes them.
     */
    FamilyMember = 1
}